// Trả trước: giá món hiển thị là giá sau thuế. BE trả thêm "price-after-vat" cạnh
// "price" (co-menu-item-details[0], topping, size...); thay vào "price" để mọi chỗ
// đọc .price (hiển thị, tổng tiền, kiểm tra giá 0...) dùng giá sau thuế.
// Giá gốc được giữ ở "price-before-vat".
// Combo: giá combo nằm ở combos[].price (không có co-menu-item-details), nên lấy giá
// sau thuế của món cùng code (menu-item.code) ở menu-groups.
// BE tính lại giá từ code món khi calculate nên giá FE gửi lên không ảnh hưởng.
export const applyPriceAfterVat = (data) => {
  if (!data || typeof data !== "object") return data;

  // Lượt 1: gom giá trước/sau thuế theo code món (trước khi bị thay).
  const priceByCode = new Map();
  const collect = (node) => {
    if (Array.isArray(node)) {
      node.forEach(collect);
      return;
    }
    if (!node || typeof node !== "object") return;
    const details = node["co-menu-item-details"];
    if (Array.isArray(details)) {
      details.forEach((detail) => {
        if (
          detail?.code !== undefined &&
          typeof detail?.["price-after-vat"] === "number"
        ) {
          priceByCode.set(String(detail.code), {
            before: detail["price-before-vat"] ?? detail.price,
            after: detail["price-after-vat"],
          });
        }
      });
    }
    Object.values(node).forEach(collect);
  };
  collect(data);

  // Lượt 2: thay giá.
  const apply = (node) => {
    if (Array.isArray(node)) {
      node.forEach(apply);
      return;
    }
    if (!node || typeof node !== "object") return;

    const comboCode = node["menu-item"]?.code;
    const comboPrice = priceByCode.get(String(comboCode));
    if (
      comboPrice &&
      typeof node.price === "number" &&
      node["price-before-vat"] === undefined &&
      node.price === comboPrice.before
    ) {
      node["price-before-vat"] = node.price;
      node.price = comboPrice.after;
    }

    // Mọi node có cả price và price-after-vat: co-menu-item-details, topping,
    // size (lst-item-size), modifier...
    if (
      typeof node.price === "number" &&
      typeof node["price-after-vat"] === "number" &&
      node["price-before-vat"] === undefined
    ) {
      node["price-before-vat"] = node.price;
      node.price = node["price-after-vat"];
    }
    Object.values(node).forEach(apply);
  };
  apply(data);

  return data;
};

export default applyPriceAfterVat;
